/**
 * 로그인 화면
 */
import React, { Component } from 'react';
import SecureLS from 'secure-ls';
import { Form, Button, Row, Col } from 'react-bootstrap';
import $ from 'jquery';
import { Redirect, Link } from "react-router-dom";
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, AlertModal, setUsrInfo, openAlert } from '../common/common';
import loader from '../imgs/ajax-loader.gif';
import logoBi from '../logo-bi.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSchool, faKey, faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';

class LoginCmp extends Component {
  constructor(props) {
    super(props);

    const userGu = props.match.params.userGu;

    this.state = {

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      userGu: userGu,
      validated: false,
      idLabelNm: userGu === 'T' ? '사용자ID' : '조회 아이디',
      pwLabelNm: userGu === 'T' ? '비밀번호' : '비밀번호 (8자리 ~ 16자리)',
      userSe: userGu === 'T' ? 'USR' : 'STDT',
      loginSuccess: false
    }
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT' && data.STD_CD !== '') {
        this.props.history.push('/stdt/ruleList');
      } else if (data !== null && data.userSe === 'STDT' && data.STD_CD === '') {
        this.props.history.push('/joinStdt');
      } else if (data !== null && data.userSe === 'USR') {
        this.props.history.push('/menuList');
      } else {
        // 자동 로그인 체크
        var ls = new SecureLS({
          encodingType: 'aes',
          isCompression: false,
          encryptionSecret: '1e83a92d7d078016391819c4ab7bd561'
        });

        $("#scId").val(ls.getDataFromLocalStorage('scId') === 'undefined' ? '' : ls.getDataFromLocalStorage('scId'));
        $("#id").val(ls.getDataFromLocalStorage('id'));
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    const that = this;

    if (form.checkValidity()) {
      udfInlineLoading();

      // 로그인
      $.ajax({
        url: url + '/uat/uia/actionLogin.do',
        type: 'GET',
        dataType: "jsonp",
        data: {
          id: $('#id').val()
          , password: $('#password').val()
          , userSe: this.state.userSe
          , isMobile: 'Y'
          , scId: $("#scId").val()
        },
        success: function (data) {
          udfNoneLoading();
          var ls = new SecureLS({
            encodingType: 'aes',
            isCompression: false,
            encryptionSecret: '1e83a92d7d078016391819c4ab7bd561'
          });

          if (data.success === true) {
            setUsrInfo(data);
            if (data.SVC_GU !== 'A') {
              ls.setDataToLocalStorage('password', "");
              openAlert(that, "메신저 전용 계정으로 로그인 할 수 없습니다.");
            } else {
              // 자동 로그인 정보 저장
              if ($("#autoLoginCheck").prop("checked") === true) {
                ls.setDataToLocalStorage('scId', $("#scId").val());
                ls.setDataToLocalStorage('id', $("#id").val());
                ls.setDataToLocalStorage('password', $("#password").val());
              }
              that.setState({
                loginSuccess: true
              });
            }
          } else {
            // ls.setDataToLocalStorage('scId', "");
            // ls.setDataToLocalStorage('id', "");
            ls.setDataToLocalStorage('password', "");
            openAlert(that, "로그인 실패!\n\n" + data.message);
          }
        },
        error: function (jqXHR, status, error) {
          udfNoneLoading();
          openAlert(that, "로그인 도중 오류가 발생했습니다. 다시 시도해주세요.");
          console.log("Request failed in LoginCmp.js: ", jqXHR, status, error, jqXHR.responseText);
        }
      });
    }

    this.setState({ validated: true });
  }

  render() {
    const { validated } = this.state;

    return (
      <div className="container-fluid App-header">
        <AlertModal
          show={this.state.alertShow}
          onHide={this.alertClose}
          Title="스쿨라이프"
          Message={this.state.alertMessage}
          onClickOk={this.state.alertClickOk}
          onClickNo={this.state.alertClickNo}
          onClickYes={this.state.alertClickYes}
        />

        <div onClick={() => { this.props.history.go(-1) }} className="btn-back"><FontAwesomeIcon icon={faArrowCircleLeft} /></div>
        <div className="wrap-loading d-none">
          <img src={loader} alt="로딩 이미지" />
        </div>
        {
          this.state.loginSuccess ?
            this.state.userSe === 'USR' ? <Redirect to="/menulist" /> : <Redirect to="/stdt/ruleList" />
            :
            <Form
              className="loginForm col"
              noValidate
              validated={validated}
              onSubmit={e => this.handleSubmit(e)}
              style={{ maxWidth: '340px', textAlign: 'center' }}
            >
              <img src={logoBi} alt="스쿨라이프" style={{ width: "90%", marginBottom: '1rem' }} />
              {
                this.state.userGu === 'T' ?
                  <Form.Group controlId="scId" className="has-feedback has-feedback-left">
                    <Form.Control type="text" className="login form-control-lg" placeholder="학교ID" aria-describedby="scId" required />
                    <FontAwesomeIcon icon={faSchool} className="form-control-feedback login" />
                    <Form.Control.Feedback type="invalid">
                      학교ID를 입력해주세요.
                    </Form.Control.Feedback>
                  </Form.Group> : null
              }
              <Form.Group controlId="id" className="has-feedback has-feedback-left">
                <Form.Control type="text" className="login form-control-lg" placeholder={this.state.idLabelNm} aria-describedby="id" required />
                <FontAwesomeIcon icon={faUser} className="form-control-feedback login" />
                <Form.Control.Feedback type="invalid">
                  {this.state.idLabelNm}를 입력해주세요.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="password" className="has-feedback has-feedback-left">
                <Form.Control type="password" className="login form-control-lg" placeholder={this.state.pwLabelNm} aria-describedby="password" required />
                <FontAwesomeIcon icon={faKey} className="form-control-feedback login" />
                <Form.Control.Feedback type="invalid">
                  {this.state.pwLabelNm}를 입력해주세요.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Row} controlId="autoLoginCheck">
                <Col sm={{ span: 10, offset: 2 }}>
                  <Form.Check label="자동 로그인" />
                </Col>
              </Form.Group>
              <Button type="submit" className="btn btn-lg btn-height btn-school-life col">로그인</Button>
              <Row style={{ marginTop: '1rem' }}>
                <Col className="text-nowrap text-left"><Link to="/Terms">이용약관</Link></Col>
                <Col className="text-nowrap"><Link to="/Private">개인정보처리방침</Link></Col>
                <Col className="text-nowrap text-right"><Link to="/JoinStdt">회원가입</Link></Col>
              </Row>
              <Row style={{ marginTop: '1rem' }}>
                <Col className="text-nowrap text-left"><Link to="/SearchId">아이디 찾기</Link></Col>
                <Col className="text-nowrap text-right"><Link to="/SearchPw">비밀번호 초기화</Link></Col>
              </Row>
              <p style={{ marginTop: '2rem', fontSize: '0.9rem' }}>
                Copyright(c) IDPRO Corp. All rights reserved.<br />
                고객센터 <a data-rel="external" href="tel:070-8853-8886">070-8853-8886</a> /&nbsp;
                <a data-rel="external" href="mailto:help@idpro.kr">help@idpro.kr</a>
                <br />월~금 오전9시~오후6시 (점심시간 정오~오후1시)
              </p>
            </Form>
        }
      </div>
    );
  }
}

export default LoginCmp;